import { render } from "./VotingSettings.vue?vue&type=template&id=3a928cd3"
import script from "./VotingSettings.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./VotingSettings.vue?vue&type=script&charset=utf-8&lang=js"

import "./VotingSettings.vue?vue&type=style&index=0&id=3a928cd3&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__